
<aside
  class="side-nav"
  :style="{ width: typeof width === 'number' ? `${width}px` : width }"
  role="navigation"
  aria-label="Section navigation"
>
  <!-- Side Nav Header -->
  <div v-if="$slots.header" class="side-nav__header">
    <slot name="header" />
  </div>

  <!-- Side Nav Items -->
  <div class="side-nav__list">
    <template v-for="(item, index) in items">
      <!-- Section header -->
      <div
        v-if="item.header"
        :key="`header-${index}`"
        class="side-nav__header-text"
      >
        {{ item.header }}
      </div>

      <!-- Simple nav item -->
      <side-nav-item
        v-else-if="!item.children || item.children.length === 0"
        :key="`simple-${index}`"
        :item="item"
        :is-active="item.active || false"
        default-icon="Circle"
        @click="handleItemClick(item, $event)"
      />

      <!-- Nav item with children -->
      <div
        v-else
        :key="`group-${index}`"
        class="side-nav__group"
      >
        <button
          class="side-nav__item side-nav__item--parent"
          :class="{ 'side-nav__item--expanded': isItemExpanded(index) }"
          :aria-expanded="isItemExpanded(index) ? 'true' : 'false'"
          :aria-label="`${item.label} (expandable section)`"
          @click="toggleItem(index)"
          @keydown.enter="toggleItem(index)"
          @keydown.space.prevent="toggleItem(index)"
        >
          <lucide-icon :name="item.icon || 'Circle'" :size="18" class="side-nav__icon" aria-hidden="true" />
          <span class="side-nav__label">
            {{ item.label }}
          </span>
          <lucide-icon
            :name="isItemExpanded(index) ? 'ChevronUp' : 'ChevronDown'"
            :size="16"
            class="side-nav__chevron"
            aria-hidden="true"
          />
        </button>

        <div
          v-if="isItemExpanded(index)"
          class="side-nav__children"
          role="group"
          :aria-label="`${item.label} submenu`"
        >
          <side-nav-item
            v-for="(child, childIndex) in item.children"
            :key="childIndex"
            :item="child"
            :is-child="true"
            :is-active="child.active || false"
            default-icon="Circle"
            @click="handleItemClick(child, $event)"
          />
        </div>
      </div>
    </template>
  </div>

  <!-- Side Nav Footer -->
  <div v-if="$slots.footer" class="side-nav__footer">
    <slot name="footer" />
  </div>
</aside>
